<template>
  <v-container class="fullWidthBanner color3" dark id="contactMe">
    <v-row>
      <v-col cols="12">
        <v-img src="@/assets/email.svg" max-height="75" contain transition="fab-transition"></v-img>
      </v-col>
    </v-row>
    <v-row>
      <div class="text-center" style="margin: auto;">
        <h3 class="display-1 background--text">{{ $t("contactTitle") }}</h3>
      </div>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="text-center background--text">
          <p>{{ $t("contactDescription") }}</p>
        </div>
      </v-col>
    </v-row>
    <v-form v-model="contactFormValid" ref="contactForm">
      <v-container class="contactFormContainer">
        <v-row>
          <v-col cols="6" class="contactCol">
            <v-text-field
              dark
              outlined
              name="firstName"
              :label="$t('firstName')"
              v-model="formInputs.firstName"
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="contactCol">
            <v-text-field
              dark
              outlined
              name="lastName"
              :label="$t('lastName')"
              v-model="formInputs.lastName"
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="contactCol" cols="12">
            <v-text-field
              dark
              outlined
              name="email"
              :label="$t('email')"
              v-model="formInputs.email"
              :rules="[rules.email]"
              data-qev-email-field
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="contactCol" cols="12">
            <v-textarea
              dark
              outlined
              name="message"
              :label="$t('message')"
              v-model="formInputs.message"
              :rules="[rules.required]"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="contactCol" cols="12">
            <v-checkbox dark v-model="formInputs.dataConsent" :label="$t('dataProtectionLabel')">
              <template v-slot:label>
                <div>
                  {{ $t('dataProtectionLabel') }}
                  <span class="linkSpan" @click="gotoRoute('privacyPolicy')">Privacy Policy</span> and
                  <span class="linkSpan" @click="gotoRoute('termsAndConditions')">Terms & Conditions</span>
                </div>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <span class="background--text">
            <i>{{ $t("requiredField") }}</i>
          </span>
        </v-row>
        <br />
        <v-row>
          <v-btn
            tile
            color="success"
            :disabled="!contactFormValid || !formInputs.dataConsent"
            @click="sendMessage()"
          >{{ $t("sendMessage") }}</v-btn>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ContactBanner",
  data() {
    return {
      contactFormValid: false,
      formInputs: {
        firstName: "",
        lastName: "",
        email: "",
        message: "",
        dataConsent: false
      },
      rules: {
        required: value => !!value || "Required",
        email: value => (!!value && this.validEmail(value)) || "Invalid e-mail"
      }
    };
  },
  computed: {
    ...mapGetters(["loading", "getExploreBannerData"])
  },
  methods: {
    ...mapActions(["sendMessageFromUser"]),
    sendMessage() {
      this.$refs.contactForm.validate();
      const msgParams = {
        firstName: this.formInputs.firstName,
        lastName: this.formInputs.lastName,
        email: this.formInputs.email,
        message: this.formInputs.message
      };
      this.sendMessageFromUser(msgParams);
      this.$refs.contactForm.reset();
      this.logEvent("button_click", {
        name: "sendMessage",
        params: msgParams
      });
    }
  }
};
</script>

<style scoped>
p {
  font-size: 1.1em;
}
.contactFormContainer {
  padding-left: 5%;
  padding-right: 5%;
}
.contactCol {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.linkSpan {
  cursor: pointer;
  text-decoration: underline;
}
</style>